import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardRoutingModule } from "./dashboard-routing.module";
import { DashboardComponent } from "./dashboard.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { BodyComponent } from "./body/body.component";
import { HttpClientModule} from "@angular/common/http";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { FormsModule } from "@angular/forms";
import { CoreModule } from "src/app/_core/core.module";
import { HighlightDirective } from "./highlight.directive";
@NgModule({
  declarations: [DashboardComponent, HeaderComponent, FooterComponent, BodyComponent, HighlightDirective],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    HttpClientModule,
    AngularEditorModule,
    CoreModule,
    FormsModule]
})
export class DashboardModule { }
